var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"action-open-chat-social"},[_c('div',{staticClass:"title",domProps:{"innerHTML":_vm._s(_vm.title)}}),(_vm.body)?_c('div',{staticClass:"body",domProps:{"innerHTML":_vm._s(_vm.body)}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }